enum CollaboratorRole {
    Collaborator = 1,
    Author,
    Assignee,
    Contributor,
}

export default CollaboratorRole;
